var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEstimatedGain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_485_4988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4291 12.8571C19.6896 12.8571 23.1434 11.3221 23.1434 9.42857C23.1434 7.53502 19.6896 6 15.4291 6C11.1686 6 7.71484 7.53502 7.71484 9.42857C7.71484 11.3221 11.1686 12.8571 15.4291 12.8571Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71484 9.42871V19.7144C7.71484 21.6001 11.1434 23.143 15.4291 23.143C19.7148 23.143 23.1434 21.6001 23.1434 19.7144V9.42871",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1434 14.5715C23.1434 16.4572 19.7148 18.0001 15.4291 18.0001C11.1434 18.0001 7.71484 16.4572 7.71484 14.5715",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2574 2.58652C13.2543 1.3503 10.9226 0.752422 8.57171 0.872223C4.30314 0.872223 0.857422 2.41509 0.857422 4.3008C0.857422 5.31223 1.85171 6.2208 3.42885 6.87223",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42885 17.1579C1.85171 16.5065 0.857422 15.5979 0.857422 14.5865V4.30078",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42885 12.015C1.85171 11.3636 0.857422 10.455 0.857422 9.4436",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_4988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstimatedGain);
export default __webpack_public_path__ + "static/media/icon-estimated-gain.96bbd29320e7c7b17a3845cd0170a614.svg";
export { ForwardRef as ReactComponent };